class CollectionWithImage extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()

    if (!this.els.slides || this.els.slides.length === 0) return
    if (this.els.slide.length < 2) return

    this.initialise(
      this.els.prev?.element,
      this.els.next?.element,
    )
  }

  initialise (prevEl, nextEl) {
    this.carouselInstance = new window.KeenSlider(
      this.els.slides.element,
      {
        selector: this.els.slide.selector,
        slides: {
          perView: 2,
          spacing: 8,
        },
      },
      [
        window.BAO.Carousel.plugins.useInitialised(),
        window.BAO.Carousel.plugins.useArrows({
          next: nextEl,
          previous: prevEl,
        }),
      ],
    )
  }
}

if (!customElements.get('collection-with-image')) {
  customElements.define('collection-with-image', CollectionWithImage)
}
